import {
    AUTH_REQUEST,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT,
    MESSAGE_SHOW,
    MESSAGE_HIDE,
    SET_ALERT,
    REFRESH_TOKEN,
    UPDATE_TOKEN
} from "../actions/auth";
import {USER_REQUEST} from "../actions/user";
import {RESET_DASHBOARD_STATE} from "../actions/dashboard";
import router from "../../router";
// utils
import apiCall from "../../utils/api";

const state = {
    token: localStorage.getItem("user-token") || "",
    status: "",
    hasLoadedOnce: false,
    messageShow: false
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    messageShow: state => state.messageShow
};

const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            // set status to loading
            commit(AUTH_REQUEST);
            // make the call
            apiCall.login(user)
                .then(resp => {
                    // if ok, set token to storage, set success, get user, resolve to component
                    localStorage.setItem("user-token", resp.data.token);
                    commit(AUTH_SUCCESS, resp);
                    dispatch(USER_REQUEST);
                    resolve(resp);
                })
                .catch(err => {
                    // if error, set error, remove token, reject to component
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem("user-token");
                    reject(err);
                });
        });
    },
    [AUTH_LOGOUT]: ({commit, dispatch},) => {
        return new Promise((resolve) => {
            apiCall.logout()
                .then(resp => {
                    commit(AUTH_LOGOUT);
                    commit(RESET_DASHBOARD_STATE);
                    localStorage.removeItem("user-token");
                    resolve(resp);
                })
                .catch(err => {
                    commit(AUTH_LOGOUT);
                    commit(RESET_DASHBOARD_STATE);
                    console.log("ERROR in auth - auth-logout", err);
                    router.push({name: 'login'});
                    dispatch(SET_ALERT);
                    localStorage.removeItem("user-token");
                });
        });
    },
    [REFRESH_TOKEN]: ({commit, dispatch, state}) => {
        return new Promise((resolve) => {
            apiCall.refreshToken({"token": state.token})
                .then(resp => {
                    commit(UPDATE_TOKEN, resp);
                    resolve(resp);
                })
                .catch(() => {
                    dispatch(AUTH_LOGOUT);
                });
        });
    },
    [MESSAGE_HIDE]: ({commit}) => {
        commit(MESSAGE_HIDE);
    },
    [SET_ALERT]: ({commit}) => {
        commit(MESSAGE_SHOW);
        setTimeout(() => {
            commit(MESSAGE_HIDE);
        }, 3000);
    }
};

const mutations = {
    [AUTH_REQUEST]: state => {
        state.status = "loading";
    },
    [AUTH_SUCCESS]: (state, resp) => {
        state.status = "success";
        state.token = resp.data.token;
        state.hasLoadedOnce = true;
    },
    [AUTH_ERROR]: state => {
        state.status = "error";
        state.hasLoadedOnce = true;
    },
    [AUTH_LOGOUT]: state => {
        state.status = "";
        state.token = "";
    },
    [MESSAGE_SHOW]: state => {
        state.messageShow = true;
    },
    [MESSAGE_HIDE]: state => {
        state.messageShow= false;
    },
    [UPDATE_TOKEN]: (state, resp) => {
        state.token = resp.data.token;
        localStorage.setItem("user-token", resp.data.token);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};